import { render, staticRenderFns } from "./OrdenTaller.vue?vue&type=template&id=36e1efbe&"
import script from "./OrdenTaller.vue?vue&type=script&lang=js&"
export * from "./OrdenTaller.vue?vue&type=script&lang=js&"
import style0 from "./OrdenTaller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports